// extracted by mini-css-extract-plugin
export default {"container":"DSISearchTemplates_container__1N+PH"};